import React from "react"
import conf_room_img from "../../../../../assets/images/round-table-icon.svg"
import meeting_room_img from "../../../../../assets/images/meeting-room-icon.svg"

export const kotData = [
    {
        id: 1,
        kot_id: "T-001",
        room_type_icon: conf_room_img,
        service_type: "(Table Service)",
        guest_name: "Mr. John Doe",
        meal_types: {
            meal_1: "Meal",
            meal_2: "Pasta",
            meal_3: "Salads",
            meal_4: "Apple Juice",
            meal_5: "Snack"
        },
         meal_types_count: {
            meal_1: "02",
            meal_2: "01",
            meal_3: "01",
            meal_4: "01",
            meal_5: "02",
        }
    },
    {
        id: 2,
        kot_id: "R-101",
        room_type_icon: meeting_room_img,
        service_type: "(Room Service)",
        guest_name: "Ms. Jane Smith",
        meal_types: {
            meal_1: "Meal",
            meal_2: "Pasta",
            meal_3: "Salads",
            meal_4: "Apple Juice",
            meal_5: "Snack"
        },
         meal_types_count: {
            meal_1: "02",
            meal_2: "01",
            meal_3: "01",
            meal_4: "01",
            meal_5: "02",
        }
    },
    {
        id: 3,
        kot_id: "T-002",
        room_type_icon: conf_room_img,
        service_type: "(Table Service)",
        guest_name: "Mr. Emily Johnson",
        meal_types: {
            meal_1: "Meal",
            meal_2: "Pasta",
            meal_3: "Salads",
            meal_4: "Apple Juice",
            meal_5: "Snack"
        },
         meal_types_count: {
            meal_1: "02",
            meal_2: "01",
            meal_3: "01",
            meal_4: "01",
            meal_5: "02",
        }
    },
    {
        id: 4,
        kot_id: "R-102",
        room_type_icon: meeting_room_img,
        service_type: "(Room Service)",
        guest_name: "Mr. Michael Brown",
        meal_types: {
            meal_1: "Meal",
            meal_2: "Pasta",
            meal_3: "Salads",
            meal_4: "Apple Juice",
            meal_5: "Snack"
        },
        meal_types_count: {
            meal_1: "02",
            meal_2: "01",
            meal_3: "01",
            meal_4: "01",
            meal_5: "02",
        }
    },
    {
        id: 5,
        kot_id: "T-003",
        room_type_icon: conf_room_img,
        service_type: "(Table Service)",
        guest_name: "Ms. Sarah Davis",
        meal_types: {
            meal_1: "Meal",
            meal_2: "Pasta",
            meal_3: "Salads",
            meal_4: "Apple Juice",
            meal_5: "Snack"
        },
         meal_types_count: {
            meal_1: "02",
            meal_2: "01",
            meal_3: "01",
            meal_4: "01",
            meal_5: "02",
        }
    },
]